import { api_12bb_variables,get_axios_file_download_instance,get_axios_instance,get_axios_nest_regenerate_instance,get_axios_report_instance, api_variables, api_regenerate_report_variables, api_new_report_variables, errorHandler,get_axios_nest_instance, api_nest_variables, get_axios_file_download_payslip_instance } from '@/apis/variables.js';

//var axios_instance_payslip = get_axios_file_download_payslip_instance(api_variables.SERVICE_PAYSLIP);
var axios_instance_payslip = get_axios_file_download_instance(api_variables.SERVICE_PAYSLIP);
var axios_instance_itsheet = get_axios_file_download_instance(api_variables.SERVICE_ITSHEET);
var axios_instance_new_payslip_sheet = get_axios_nest_instance(api_nest_variables.SERVICE_DOWNLOAD_NEW_PAYSLIP);
var axios_instance_new_additional_payslip_sheet = get_axios_nest_instance(api_12bb_variables.SERVICE_DOWNLOAD_ADDITIONAL_PAYSLIP)
var axios_instance_form16_available_check = get_axios_nest_instance(api_12bb_variables.SERVICE_FORM_16_AVAILABLE_CHECK)
var axios_instance_new_it_sheet = get_axios_nest_instance(api_nest_variables.SERVICE_DOWNLOAD_NEW_ITSHEET);
var axios_instance_ctc_report = get_axios_nest_instance(api_nest_variables.SERVICE_DOWNLOAD_CTC_REPORT_NEW);
var axios_instance_send_emp_details =  get_axios_nest_instance(api_nest_variables.SERVICE_SHARE_EMP_DATA);
var axios_instance_ctc_report_data =  get_axios_nest_instance(api_nest_variables.SERVICE_CTC_DATA);
var axios_instance_Ytdsheet = get_axios_instance(api_variables.SERVICE_YTDSHEET);
var axios_instance_get_client_admin_payroll = get_axios_instance(api_variables.SERVICE_GET_CLIENT_ADMIN_PAYSLIP_MONTHS);
var axios_instance_bulk_payslip = get_axios_nest_instance(api_nest_variables.SERVICE_BULK_PAYSLIP);
var axios_instance_bulk_payslip_details = get_axios_nest_instance(api_nest_variables.SERVICE_BULK_PAYSLIP_DETAILS);
var axios_instance_bulk_payslip_data = get_axios_nest_instance(api_nest_variables.SERVICE_BULK_PAYSLIP_DATA);
var axios_instance_upload_previous_payslip_itsheet = get_axios_nest_instance(api_nest_variables.SERVICE_UPLOAD_PREVIOUS_PAYSLIPS_ITSHEET);
var axios_instance_upload_form_general = get_axios_nest_instance(api_nest_variables.SERVICE_UPLOAD_FORM_GENERAL)
var axios_instance_general_upload = get_axios_nest_instance(api_nest_variables.SERVICE_UPLOAD_GENERAL)
var axios_instance_get_upload_logs = get_axios_nest_instance(api_nest_variables.SERVICE_GET_UPLOAD_LOGS);
var axios_instance_get_form_logs=get_axios_nest_instance(api_nest_variables.SERVICE_GET_FORM_LOGS);
var axios_instance_get_general_logs=get_axios_nest_instance(api_nest_variables.SERVICE_GET_GENERAL_LOGS)
var axios_instance_get_logs_presigned_url = get_axios_nest_instance(api_nest_variables.SERVICE_GET_UPLOAD_PRESIGNED_URL);
var axios_instance_get_download_form= get_axios_nest_instance(api_nest_variables.SERVICE_GET_DOWNLOAD_FORM)
var axios_instance_get_form_report_download= get_axios_nest_instance(api_nest_variables.SERVICE_FORM_REPORT_DOWNLOAD)
var axios_instance_get_download_general= get_axios_nest_instance(api_nest_variables.SERVICE_GET_DOWNLOAD_GENERAL)
var axios_instance_ess_download_general_report= get_axios_nest_instance(api_nest_variables.SERVICE_ESS_DOWNLOAD_GENERAL)
var axios_instance_add_document_list= get_axios_nest_instance(api_nest_variables.SERVICE_ADD_DOCUMENT_LIST)
var axios_instance_get_document_list= get_axios_nest_instance(api_nest_variables.SERVICE_GET_DOCUMENT_LIST)
var axios_instance_update_ctc_status = get_axios_nest_instance(api_nest_variables.SERVICE_UPDATE_CTC_STATUS);
var axios_instance_get_client_admin_payroll_global = get_axios_instance(api_variables.SERVICE_GET_CLIENT_ADMIN_PAYSLIP_MONTHS_GLOBAL);
var axios_instasnce_generate_payroll_reports = get_axios_nest_regenerate_instance(api_regenerate_report_variables.SERVICE_GENERATE_IT_SHEET_EXCEL)
var axios_download_reports =  get_axios_nest_instance(api_nest_variables.SERVICE_DOWNLOAD_REPORTS);
var axios_instance_clear_tax_integration=get_axios_nest_instance(api_nest_variables.SERVICE_CLEAR_TAX_FORM_16_INTEGRATION);
const _pk_name = "id";

const actions = {


    async downloadPayslip({ commit }, payload) {
        try {
            let res = await axios_instance_payslip.get(``, {
                params: {
                    //id: payload
                    le_id: payload.le_id,
                    empId: payload.empId,
                    org_id: payload.org_id,
                    paygroup_id: payload.paygroup_id,
                    financialYear:payload.financialYear,
                    month: payload.month
                }
            });

            // //console.log("Checking",res);
            // //console.log("Checking Blob--> ",res.data);
            // //console.log("Checking Data",typeof res.data);
            
            if(res.data instanceof Blob) {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Salary_payslip.pdf"); //or any other extension
                document.body.appendChild(link);
                link.click();
                return res;
            }
            // //console.log("Payslip Res",res);
            // //console.log("typeof res.data",typeof res.data);
            // if(typeof res.data === 'string'){
            //     const url = window.URL.createObjectURL(new Blob([res.data]));
            //     //console.log("URL",url);
            //     const link = document.createElement("a");
            //     link.href = url;
            //     link.setAttribute("download", "Salary_payslip.pdf"); //or any other extension
            //     document.body.appendChild(link);
            //     link.click();
            //     return res;
            // }
            // //  Logical added in if condition to download payslip
            // if(res.data.data.payload.payslip_url){
            //     //console.log("Payslip Data",res.data.data.payload);
            //     const link = document.createElement("a");
            //     // link.download =  `Salary_payslip${payload.month}${payload.financialYear}.pdf`;
            //     link.href = res.data.data.payload.payslip_url;
            //     document.body.appendChild(link);
            //     link.click();
            //     document.body.removeChild(link);
            //     return res;
            // } else{
            //     const url = window.URL.createObjectURL(new Blob([res.data]));
            //     //console.log("URL",url);
            //     const link = document.createElement("a");
            //     link.href = url;
            //     link.setAttribute("download", "Salary_payslip.pdf"); //or any other extension
            //     document.body.appendChild(link);
            //     link.click();
            //     return res;
            // }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    
    async downloadITSheet({ commit }, payload) {
        try {
            let res = await axios_instance_itsheet.get(``, {
                params: {
                    //id: payload
                    le_id: payload.le_id,
                    empId: payload.empId,
                    financialYear:payload.financialYear,
                    month: payload.month
                }
            });
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "IT_Sheet.pdf"); //or any other extension
            document.body.appendChild(link);
            link.click();
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async downloadYtdsheet({ commit }, payload) {
        try {
            let res = await axios_instance_Ytdsheet.get(``, {
                params: {
                    //id: payload
                    employee_id: payload.employee_id ?  payload.employee_id : payload.empId,
                    financialYear:payload.financial_year ? payload.financial_year : payload.financialYear ,
                    role:payload.role ? payload.role: payload.role,
                    month:payload.month? payload.month: payload.month,
                    legal_entity_id:payload.legal_entity_id
                }
            });
            // const url = window.URL.createObjectURL(new Blob([res.data]));
            // console.log(url);
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "YTD_Report.xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async downloadNewPayslips({ commit }, payload) {
        try {
            let res = await axios_instance_new_payslip_sheet.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async downloadNewAdditionalPayslips({ commit }, payload) {
        try {
            let res = await axios_instance_new_additional_payslip_sheet.post(``, payload);
            return res;
        } catch (error) {
            throw errorHandler(error);
        }   
    },
    async fetchForm16AvailableCheck({commit},payload) {
        try {
            console.log("ayloadf",payload)
              let res = await axios_instance_form16_available_check.get('',{
                params:{
                   emp_code:payload.emp_code,
                   le_id:payload.le_id,
                   type:payload.type
                }
              })
              return res
        } catch (err) {
             
        }
    },
       async downloadNewItsheet({ commit }, payload) {
        try {
            let res = await axios_instance_new_it_sheet.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async downloadBulkPayslips({ commit }, payload) {
        try {
            let res = await axios_instance_bulk_payslip.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async downloadBulkPayslipsdetails({ commit }, payload) {
        try {
            let res = await axios_instance_bulk_payslip_details.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async downloadBulkPayslipsdata({ commit }, payload) {
        try {
            let res = await axios_instance_bulk_payslip_data.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async downloadCtcReport({ commit }, payload) {
        try {
            let res = await axios_instance_ctc_report.post(``, payload);
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async updateCtcReportStatus({ commit }, payload) {
        try {
            let res = await axios_instance_update_ctc_status.put(``, payload);
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
    async postEmpDetails({ commit }, payload) {
        try {
            // console.log(payload)
            let res = await axios_instance_send_emp_details.post(``, payload);
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async generateItsheetExcel({ commit }, payload) {
        try {
            let res = await axios_instasnce_generate_payroll_reports.post(``, payload);
            return res;
        } catch (error) {
            throw error;
        }
    },

    async ctcReport({ commit }, payload) {
        try {
            let res = await axios_instance_ctc_report_data.post(``, payload);
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async getClientAdminPayrollMonthList({ commit }, payload) {
        try {
            let res = await axios_instance_get_client_admin_payroll.get(`/`, {
                params: {
                    le_id: payload.le_id
                }
            });
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async getClientAdminPayrollMonthListGlobal({ commit }, payload) {
        try {
            let res = await axios_instance_get_client_admin_payroll_global.get(`/`, {
                params: {
                    le_id: payload.le_id
                }
            });
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },

    async uploadPreviousPayslipItsheet({ commit }, payload) {
        try {
            let res = await axios_instance_upload_previous_payslip_itsheet.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async uploadFormAndGeneral({ commit }, payload) {
        try {
            let res = await axios_instance_upload_form_general.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async uploadGeneral({ commit }, payload) {
        try {
            let res = await axios_instance_general_upload.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async addDocumentList({ commit }, payload) {
        try {
            let res = await axios_instance_add_document_list.post(``, payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
    async getDocumentList({ commit }, payload) {
        try {
            let res = await axios_instance_get_document_list.get(`/${payload.le_id}`);
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async getUploadPreviousPayslipItsheetLogs({ commit }, payload) {
        try {
            let res = await axios_instance_get_upload_logs.get(`/${payload}`);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async getUploadGeneralLogs({ commit }, payload) {
        try {
            let res = await axios_instance_get_general_logs.get(`/${payload}`);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
    async getUploadFormLogs({ commit }, payload) {
        try {
            let res = await axios_instance_get_form_logs.get(`/${payload}`);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
    async getLogsPresignedUrl({ commit }, payload) {
        try {
            let res = await axios_instance_get_logs_presigned_url.get(`/${payload}`);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
    async getDownloadGeneral({ commit }, payload) {
        try {
            let res = await axios_instance_get_download_general.get(`/${payload}`);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async getEssDownloadGeneral({ commit }, payload) {
        try {
            let res = await axios_instance_ess_download_general_report.post(``,payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
    async getDownloadForm({ commit }, payload) {
        try {
            let res = await axios_instance_get_download_form.get(`/${payload}`);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async getReportDownloadForm({ commit }, payload) {
        try {
            let res = await axios_instance_get_form_report_download.post(``,payload);
            
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    async downloadReports({ commit }, payload) {
        try {
             let res = await axios_download_reports.post(``, payload,{responseType: 'blob'});
             return res;
        } catch (error) {
            console.log("Download Reports Error",error);
             throw errorHandler(error);
        }
     },
    async clearTaxIntegration({ commit }, payload) {
        try {
            let res = await axios_instance_clear_tax_integration.post(``,payload);  
            console.log(res)        
            return res;
        } catch (error) {
            throw errorHandler(error);
        }
    },
    
}

export default {
    namespaced: true,
    actions
}